import { render, staticRenderFns } from "./DashboardDataQualityDrilldown.vue?vue&type=template&id=23565111&scoped=true"
import script from "./DashboardDataQualityDrilldown.vue?vue&type=script&lang=js"
export * from "./DashboardDataQualityDrilldown.vue?vue&type=script&lang=js"
import style0 from "./DashboardDataQualityDrilldown.vue?vue&type=style&index=0&id=23565111&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23565111",
  null
  
)

export default component.exports